import { createContext } from "react";

const LiveScoresChangeDataContext = createContext(null);
LiveScoresChangeDataContext.displayName = "LiveScoresChangeData";

const LiveScoresHoverContext = createContext(null);
LiveScoresHoverContext.displayName = "LiveScoresHover";

export { LiveScoresChangeDataContext, LiveScoresHoverContext };
